import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Div from '../Page/Div';
import FixedContainer from '../Page/FixedContainer';
import { WPImage } from '../UI/WPImage';
import ImageContainer from '../UI/ImageContainer';
import { sanitize } from '../../utils';
import { isMobileWidth, MOBILE_SAFE_RESIZE } from '../globalUtils';
const SolutionsContentSection = ({ content, idx, allowOpen, }) => {
    const [mobileView, setMobileView] = useState(isMobileWidth());
    const mobileViewRef = useRef(mobileView);
    mobileViewRef.current = mobileView;
    const { elements } = content?.solutions_content ?? {};
    const sortedElements = (elements ?? []).sort((a, b) => a.depth < b.depth ? -1 : 1);
    const [reopen, setReopen] = useState(0);
    useEffect(() => {
        window.addEventListener(MOBILE_SAFE_RESIZE, onResize);
        onResize();
        return () => {
            window.removeEventListener(MOBILE_SAFE_RESIZE, onResize);
        };
    }, []);
    const onResize = () => {
        const mobile = isMobileWidth();
        if (mobile && !mobileViewRef.current) {
            setMobileView(true);
        }
        if (!mobile && mobileViewRef.current) {
            setMobileView(false);
        }
    };
    useEffect(() => {
        if (allowOpen) {
            setReopen((x) => x + 1);
        }
    }, [allowOpen]);
    return (_jsx(FixedContainer, { blocked: !content.force_snap, idx: idx, allowOpen: allowOpen, parentClassName: `solutions-content-container`, sliderClassName: `solutions-content-wrapper`, children: sortedElements.map((item, idx) => {
            const { position, position_mobile, image, text, depth, type, title, priority, } = item;
            const pos = mobileView ? position_mobile || position : position;
            const d = parseFloat(depth ?? '0');
            return (_jsx(ImageContainer, { setup: pos, allowOpen: true, delay: 2 + Math.random() * 2, depth: d, noHeight: !image, eventParentDepth: 2, useLvh: true, children: _jsx(Div, { className: "solutions-element-wrapper", delay: d - 1, reopen: reopen, blocked: !allowOpen, children: type === 'image' ? (_jsx(WPImage, { id: image, priority: !!priority })) : type === 'text' ? (_jsx("div", { dangerouslySetInnerHTML: {
                            __html: sanitize(text),
                        } })) : null }) }, `${position}${type}`));
        }) }));
};
export default SolutionsContentSection;
